import { Outlet } from "react-router-dom";
import globalStyles from "../../assets/styles/base/globalPage.module.scss";

export const ProcurementLayout = () => {
  return (
    <div
      className={`${globalStyles?.pagePaddings} ${globalStyles.pageColumnGaps}`}
    >
      <Outlet />
    </div>
  );
};
